import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext, AppState } from 'src/AppState/AppState';
import { EventsCollectionQueryCompetitionWithEventsType } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';
import { computed, makeAutoObservable } from 'mobx';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import MarketsList from 'src/components/MarketsList/MarketsList';

import moment from 'moment';
import classNames from 'classnames';
import { EventDateWrapper } from './EventsListTabNew.styles';

interface PropsTypes {
    userId: number;
    competition: EventsCollectionQueryCompetitionWithEventsType;
}

interface GroupedEventsType {
    startTime: string;
    events: Array<EventListGroupEventItemType>;
}

class State {
    public constructor(
        private readonly appState: AppState,
        private readonly props: PropsTypes
    ) {
        makeAutoObservable(this);
    }

    @computed get eventsGroupedByDate(): Array<GroupedEventsType> {
        const tempMap: Map<string, GroupedEventsType> = new Map();

        for (const event of this.props.competition.events) {
            const startTimeMoment = moment(event.startTime);

            const startTime = startTimeMoment.format('DD-MM-YYYY');
            const groupElem = tempMap.get(startTime) ?? null;
            if (groupElem !== null) {
                groupElem.events.push(event);
                tempMap.set(startTime, groupElem);
            } else {
                tempMap.set(startTime, {
                    startTime: startTimeMoment.startOf('day').toISOString(),
                    events: [event],
                });
            }
        }

        return Array.from(tempMap.values());
    }

    onSelectEventId = (eventId: number | null) => {
        this.appState.routerBackoffice.setParamInNamespace('customers', 'event', eventId);
    };

    @computed get selectedEventId(): number | null {
        return this.appState.routerBackoffice.getParametersNumber('customers', 'event');
    }
}

export const EventsListTabNew = observer('EventsListTabNew', (props: PropsTypes) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new State(appState, props));
    const { eventsGroupedByDate, onSelectEventId, selectedEventId } = state;

    return (
        <div className='events-list'>
            <div className='row'>
                <div className='col-8'>
                    {eventsGroupedByDate.map((eventsGroup) => {
                        const timeSettingsStartTime = eventsGroup.startTime;

                        return (
                            <div
                                className='row'
                                key={timeSettingsStartTime}
                            >
                                <strong>
                                    {moment(timeSettingsStartTime).calendar(undefined, {
                                        lastWeek: '[Last] dddd',
                                        lastDay: '[Yesterday]',
                                        sameDay: '[Today]',
                                        nextDay: '[Tomorrow]',
                                        nextWeek: 'dddd',
                                        sameElse: 'MMMM DD',
                                    })}
                                </strong>
                                <div>
                                    {eventsGroup.events.map((event) => (
                                        <div
                                            key={event.id}
                                            onClick={() => onSelectEventId(event.id)}
                                            className={classNames('event', {
                                                event__highlighted: event.id === selectedEventId,
                                            })}
                                        >
                                            <EventDateWrapper>
                                                <div>{moment(event.startTime).format('DD MMM')}</div>
                                                <div>{moment(event.startTime).format('HH:mm')}</div>
                                            </EventDateWrapper>
                                            <span className='event__name'>{event.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='col-4'>
                    {selectedEventId !== null ? (
                        <MarketsList
                            userId={props.userId}
                            eventId={selectedEventId}
                            onClose={() => onSelectEventId(null)}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
});
